import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=0f79dbd2&scoped=true&"
var script = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=0f79dbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79dbd2",
  null
  
)

export default component.exports